/**
 * P3-40: Achievements tab 迁移。
 *
 * 逐结构对齐 `js/achievements.js:817-847` 的 `AchTab`：
 * - 两个 SpacePanel：成就面板 + 徽章面板
 * - 根元素 className="tabInner Achievements"
 */
import { SpacePanel } from "../space/SpacePanel";
import { TooltipProvider } from "../../components/Tooltip/TooltipProvider";
import { t } from "../../bridge/i18n";
import AchievementsPanel from "./AchievementsPanel";
import BadgesPanel from "./BadgesPanel";

export default function AchievementsTab() {
  return (
    <TooltipProvider>
      <div className="tabInner Achievements">
        <SpacePanel title={t("achievements.panel.label")}>
          <AchievementsPanel />
        </SpacePanel>
        <SpacePanel title={t("badges.panel.label")}>
          <BadgesPanel />
        </SpacePanel>
      </div>
    </TooltipProvider>
  );
}
